module.exports = __webpack_public_path__ + "static/img/cjzz.485f8c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/cjzz.jpg
// module id = morW
// module chunks = 0